module.exports = __webpack_public_path__ + "img/wxpay.894ddc6a.jpg";